/**
 * Kiosk 版本监听器
 * 提供统一的版本检测和回调机制
 */

type VersionCallback = (version: number) => void

interface KioskVersionWatcher {
  callbacks: VersionCallback[]
}

const watcher: KioskVersionWatcher = {
  callbacks: []
}



/**
 * 注册版本回调
 * @param callback 接收到版本号时的回调函数
 */
export function onKioskVersion(callback: VersionCallback): void {
  if (!watcher.callbacks.includes(callback)) {
    watcher.callbacks.push(callback)
  }
}

/**
 * 移除版本回调
 * @param callback 要移除的回调函数
 */
export function offKioskVersion(callback: VersionCallback): void {
  const index = watcher.callbacks.indexOf(callback)
  if (index > -1) {
    watcher.callbacks.splice(index, 1)
  }
}

/**
 * 通知版本信息（由中间件调用）
 * @param serverVersion 服务器返回的版本号
 */
export function notifyKioskVersion(serverVersion: number): void {
  // 直接触发所有回调，让回调函数自己决定是否需要处理
  watcher.callbacks.forEach(callback => {
    try {
      callback(serverVersion)
    } catch (error) {
      console.error('Error in kiosk version callback:', error)
    }
  })
}

/**
 * 获取监听状态 - 有注册回调就表示正在监听
 */
export function isWatchingKioskVersion(): boolean {
  return watcher.callbacks.length > 0
}

// 导出简化的别名
export const onVersion = onKioskVersion
export const offVersion = offKioskVersion